import { render, staticRenderFns } from "./PerfectInformation.vue?vue&type=template&id=704e8a6f&scoped=true&"
import script from "./PerfectInformation.vue?vue&type=script&lang=js&"
export * from "./PerfectInformation.vue?vue&type=script&lang=js&"
import style0 from "./PerfectInformation.vue?vue&type=style&index=0&id=704e8a6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704e8a6f",
  null
  
)

export default component.exports